module.exports = __webpack_public_path__ + "static/media/banner-hr.e9ec374a.jpg";